import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const value = {
    user,
    loading,
    setUser,
    refresh: checkAuth,
    logout: async () => {
      try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed; clearing session locally", e); }
      setUser(false);
    },
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}

export function homeForRole(role) {
  if (role === "corporate_admin") return "/app/corporate";
  if (role === "store_admin") return "/app/store";
  if (role === "employee") return "/app/me";
  if (role === "master_admin") return "/app/platform";
  if (role === "platform_sales") return "/app/platform/organizations";
  if (role === "platform_ops") return "/app/platform/operations";
  if (role === "platform_finance") return "/app/platform/finance";
  return "/app/corporate";
}
